import type { Node } from 'slate';

import { Element } from 'slate';

import type { FaEmojiInline } from '@ui/MarkdownEditor/types';

export const type = 'fa-emoji';
export const rdmdType = 'i';
export const isFaEmoji = (node: Node): node is FaEmojiInline => Element.isElementType(node, type);
